import { Request } from "@/services/survey-response/surveyRespondeService"
import { keysToCamel } from "../utils"

interface AuthResponse {
    accessToken: string
}

export interface User {
    sub: string
    isAdmin: boolean
    exp: number
    id: number
}

export interface SystemUser {
    disabled?: boolean
    id: number
    isAdmin: boolean
    name: string
    username: string
}

export interface UpdateUser extends Omit<SystemUser, 'id'> {
    password?: string
    confirmPassword?: string
    id?: number
}

export interface CreateUserForm extends Omit<SystemUser, 'id'> {
    password: string
    confirmPassword: string
}

export class AuthService {

    async login(username: string, password: string): Promise<AuthResponse | undefined> {
        const slug = "auth/token"

        const formData = new FormData()
        formData.append("username", username)
        formData.append("password", password)

        return await Request.post<AuthResponse>(
            slug,
            formData,
            "Error logging in: ",
            true
        );
    }

    getCurrentUser(): User | undefined {
        const token = localStorage.getItem("accessToken");
        if (!token) {
            return undefined
        }

        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return keysToCamel(JSON.parse(jsonPayload)) as User;
    }

    async getAllUsers(): Promise<SystemUser[]> {
        const slug = "manage_users/all_users"
        const result = await Request.get<SystemUser[]>(slug, "Error getting users: ");

        return result || [];
    }

    async createUser(user: CreateUserForm): Promise<SystemUser | undefined> {
        const slug = "manage_users/create_user"
        const result = await Request.post<SystemUser>(slug, user, "Error creating user: ");

        return result;
    }

    async updateUser(user: UpdateUser): Promise<SystemUser | undefined> {
        const slug = "manage_users/update_user"
        const result = await Request.post<SystemUser>(slug, user, "Error updating user: ");

        return result;
    }
}